<article
    class="flex w-full min-w-0 lg:w-[324px] lg:flex-none mt-3 md:mt-0 flex-col gap-4 overflow-visible rounded-[10px] border border-[#BFE5F8] bg-white p-4 text-sm leading-5 text-[#344054] "
    *transloco="let t; currentLang as currentLang">
    <header class="flex w-full flex-col gap-4">
        <p class="m-0 text-base font-semibold leading-6 text-[#344054]">{{ t('companyProfile') }}</p>
        <div class="flex w-full min-w-0 items-center gap-3">
            <!-- Logo -->
            <div class="flex h-[52px] w-[52px] flex-none items-center justify-center overflow-hidden rounded-md border border-[#E2F2FC] bg-white shadow-sm">
                @if (jobDetails()?.JobLOgoName) {
                <img [src]="jobDetails()?.JobLOgoName" [alt]="jobDetails()?.CompnayName + ' logo'"
                    class="h-full w-full object-contain" />
                } @else {
                <span class="text-xl font-bold text-[#C63C92]">
                    {{ (jobDetails()?.CompnayName || '') | initials }}
                </span>
                }
            </div>

            <div class="flex min-w-0 flex-1 flex-col justify-center gap-1.5">
@if (jobDetails()?.HaveAliasName === false && jobDetails()?.OnlineJob && hasCompanyInsight()) {
<button [routerLink]="'/company-insight/' + jobDetails()?.CompanyID"
    class="flex min-w-0 cursor-pointer items-center gap-1.5 border-0 bg-transparent p-0 text-left text-[#101828] hover:underline">
    <h2 class="m-0 min-w-0 max-w-[20ch] truncate text-sm font-semibold leading-5">
        {{ jobDetails()?.CompnayName }}
    </h2>

    <img [src]="environment.homeImageUrl + 'job-details-share-icon.svg'" alt="" class="h-4 w-4 flex-none" />
</button>
} @else {
<button class="flex min-w-0 cursor-pointer items-center gap-1.5 border-0 bg-transparent p-0 text-left text-[#101828]">
    <h2 class="m-0 min-w-0 max-w-[20ch] truncate text-sm font-semibold leading-5">
        {{ jobDetails()?.CompnayName }}
    </h2>
</button>
}
                @if (jobDetails()?.HaveAliasName === false) {
                <div class="flex flex-wrap items-center gap-1.5 text-xs leading-[18px] text-[#475467]">
                    @if (companyInsight()?.totalLiveJob) {
                    <span><strong>{{ currentLang === 'en' ? companyInsight()!.totalLiveJob : (companyInsight()!.totalLiveJob | toBanglaNumber) }}</strong> {{ t('jobs') }}</span>
                    }
                    @if (companyInsight()?.totalLiveJob && companyInsight()?.totalLiveJobVacancy !== null) {
                    <span class="h-1.5 w-1.5 flex-none rounded-full bg-[#D9D9D9]" aria-hidden="true"></span>
                    }
                    @if (companyInsight()?.totalLiveJobVacancy !== null) {
                    <span><strong>{{ currentLang === 'en' ? companyInsight()!.totalLiveJobVacancy : (companyInsight()!.totalLiveJobVacancy | toBanglaNumber) }}+</strong> {{ t('vacancy') }}</span>
                    }
                </div>
                }
            </div>
        </div>
    </header>

    @if (jobDetails()?.HaveAliasName === false && visibleIndustries().length > 0) {
    <div class="flex w-full flex-col gap-2">
        <div class="flex w-full items-start gap-2">
            <p class="m-0 flex-none font-semibold text-[#101828]">{{ t('industry') }}:</p>
            <div class="relative flex min-w-0 flex-1 flex-wrap items-center gap-1">
                @for (industry of visibleIndustries(); track industry; let i = $index) {
                <span [title]="industry"
                    class="max-w-[100px] sm:max-w-[130px] truncate rounded-full border border-[#E4E7EC] bg-[#F9FAFB] px-1.5 text-xs leading-5 text-[#344054]">
                    {{ industry }}
                </span>
                }
                    @if (hiddenCount() > 0) {
                    <div class="relative" (mouseenter)="tooltipOpen.set(true)" (mouseleave)="tooltipOpen.set(false)">
                        <button type="button" aria-label="Show more industries"
                            class="cursor-pointer whitespace-nowrap rounded-full border border-[#E4E7EC] bg-[#F9FAFB] px-1.5 text-xs font-semibold leading-5 text-[#344054]"
                            (click)="toggleTooltip($event)">
                            +{{ hiddenCount() }}
                        </button>

                        <div (click)="$event.stopPropagation()"
                            class="absolute left-1/2 top-[calc(100%+8px)] z-10 w-[202px] -translate-x-1/2 rounded-lg border border-[#333] bg-[#0C111D] p-3 text-xs leading-[18px] text-[#D0D5DD] shadow-xl transition-opacity duration-200"
                            [class.opacity-0]="!tooltipOpen()" [class.pointer-events-none]="!tooltipOpen()">
                            {{ hiddenIndustriesTooltipText() }}
                        </div>
                    </div>
                    }

            </div>
        </div>
        @if (jobDetails()?.CompanyAddress) {
        <div class="flex w-full flex-col">
            <p class="m-0 font-semibold text-[#101828]">{{ t('address') }}:</p>
            <p class="m-0">{{ jobDetails()?.CompanyAddress }}</p>
        </div>
        }
        @if (jobDetails()?.CompanyWeb) {
        <div class="flex w-full flex-col">
            <p class="m-0 font-semibold text-[#101828]">{{ t('website') }}:</p>
            <a [innerHTML]="jobDetails()?.CompanyWeb" [href]="CompanyWeb()" class="break-words text-[#0E73A9] underline"></a>
        </div>
        }
    </div>
    }
<!-- 
    @if (jobDetails()?.CompanyBusiness) {
        <div class="text-[13px] leading-5 text-[#344054]">
            <span [innerHTML]="displayComBusiness()" class="leading-[20px]"></span>

            @if (shouldShowSeeMoreButton()) {
            <button type="button" class="ml-1 cursor-pointer border-0 bg-transparent p-0 font-medium text-[#0E6596] underline"
                (click)="onToggleBusiness()">
                {{ isCompanyBusinessExpanded() ? 'See less' : 'See more' }}
            </button>
            }
        </div>
    } -->

    @if (jobDetails()?.HaveAliasName === false && jobDetails()?.OnlineJob && hasCompanyInsight()) {
    <div class="w-full overflow-hidden rounded-[10px] bg-[#E6F3FE] px-3 py-5">
        <img ngSrc="images/job-details-comapny-insight-icon.png" width="351" height="165"
            class="block h-auto w-full rounded object-contain" alt="" />
    </div>
<button (click)="onFollow()"
    class="flex min-h-9 w-full cursor-pointer items-center justify-center gap-2 rounded-lg border px-3 py-2 text-sm font-semibold leading-5 shadow-sm transition-colors"
    [class.bg-[#0E73A9]]="!isFollowedLocal()" [class.border-[#0E73A9]]="!isFollowedLocal()"
    [class.text-white]="!isFollowedLocal()" [class.hover:bg-[#0E6596]]="!isFollowedLocal()"
    [class.bg-white]="isFollowedLocal()" [class.border-[#D0D5DD]]="isFollowedLocal()"
    [class.text-[#344054]]="isFollowedLocal()" [class.hover:bg-[#F9FAFB]]="isFollowedLocal()">
    <img aria-hidden="true" class="h-5 w-5 flex-none" [src]="
    isFollowedLocal()
      ? environment.homeImageUrl + 'company-insight-following-check-icon.svg'
      : environment.homeImageUrl + 'company-insight-follow-plus-icon.svg'
  " alt="" />
    <span>{{ isFollowedLocal() ? t('following') : t('follows') }}</span>
</button>
    <div class="relative flex w-full flex-col gap-4">
        <button [routerLink]="'/company-insight/' + jobDetails()?.CompanyID" class="flex min-h-9 w-full cursor-pointer items-center justify-center gap-2 rounded-lg border border-[#86CFF3] bg-white px-3 py-2 text-sm font-semibold leading-5 text-[#0E6596] shadow-sm">
            <img [src]="environment.homeImageUrl + 'view-company-insight-icon.svg'" class="h-5 w-5 flex-none" alt="" />
            <span>{{ t('voewcompanmyinsight') }}</span>
        </button>
        <img [src]="environment.homeImageUrl + 'pro-badge.svg'" class="absolute -right-1 -top-2 h-[15px] w-[45px]" alt="PRO" />
    </div>
    } @else if (jobDetails()?.HaveAliasName === false) {
<button (click)="onFollow()"
    class="flex min-h-9 w-full cursor-pointer items-center justify-center gap-2 rounded-lg border px-3 py-2 text-sm font-semibold leading-5 shadow-sm transition-colors"
    [class.bg-[#0E73A9]]="!isFollowedLocal()" [class.border-[#0E73A9]]="!isFollowedLocal()"
    [class.text-white]="!isFollowedLocal()" [class.hover:bg-[#0E6596]]="!isFollowedLocal()"
    [class.bg-white]="isFollowedLocal()" [class.border-[#D0D5DD]]="isFollowedLocal()"
    [class.text-[#344054]]="isFollowedLocal()" [class.hover:bg-[#F9FAFB]]="isFollowedLocal()">
    <img aria-hidden="true" class="h-5 w-5 flex-none" [src]="
    isFollowedLocal()
      ? environment.homeImageUrl + 'company-insight-following-check-icon.svg'
      : environment.homeImageUrl + 'company-insight-follow-plus-icon.svg'
  " alt="" />
    <span>{{ isFollowedLocal() ? t('following') : t('follows') }}</span>
</button>
    }
</article>
